import _debounce from 'lodash.debounce'
import Debug from 'logdown'

import {
  VUEX_NOTIFICATIONS_SHOW,
  VUEX_NOTIFICATIONS_HIDE,

  VUEX_NOTIFICATIONS_SET_STATE,
  VUEX_NOTIFICATIONS_ADD_TO_QUEUE,
  VUEX_NOTIFICATIONS_ADD_TO_QUEUE_DEBOUNCED,
  VUEX_NOTIFICATIONS_PROCCESS,
  VUEX_NOTIFICATIONS_CYCLE_COMPLETE,
  VUEX_NOTIFICATIONS_CLEAR_NOTIFICATION
} from '@/store/constants/ui/notifications'

const d = new Debug('its:modules:notifications:store')

const state = {
  notificationsQueue: [],
  hasNotificationsPending: false,

  component: null,
  data: null,
  timeout: null,
  openState: false
}

const getters = {
  numberOfNotifications: state => {
    return state.notificationsQueue.length
  },

  hasNotificationsPending: state => {
    return state.notificationsQueue.length > 0
  }
}

const actions = {
  [VUEX_NOTIFICATIONS_SHOW]: ({ commit }, payload) => {
    commit(VUEX_NOTIFICATIONS_SHOW, payload)
  },

  [VUEX_NOTIFICATIONS_HIDE]: ({ commit }) => {
    commit(VUEX_NOTIFICATIONS_HIDE)
  },

  [VUEX_NOTIFICATIONS_SET_STATE]: ({ commit, dispatch }, payload) => {
    commit(VUEX_NOTIFICATIONS_SET_STATE, payload)
    setTimeout(() => {
      dispatch(VUEX_NOTIFICATIONS_CYCLE_COMPLETE)
    }, 1000)
  },

  // adds to queue, but after a debounce timer
  // we added a feature to alert user on validation errors in the KI assortment grid manager
  // but this might trigger sometimes dozens of cells at once on group edit features.  Hence, the need to debounce it in some cases.
  [VUEX_NOTIFICATIONS_ADD_TO_QUEUE_DEBOUNCED]: _debounce(async ({ dispatch, commit }, payload) => {
    dispatch(VUEX_NOTIFICATIONS_ADD_TO_QUEUE, payload)
  }, 250),

  [VUEX_NOTIFICATIONS_ADD_TO_QUEUE]: async ({ dispatch, commit }, payload) => {
    d.log('Added notification to queue', { payload })
    await commit(VUEX_NOTIFICATIONS_ADD_TO_QUEUE, payload)
    dispatch(VUEX_NOTIFICATIONS_PROCCESS)
  },

  [VUEX_NOTIFICATIONS_PROCCESS]: ({ rootState, state, getters, dispatch }) => {
    if (getters.hasNotificationsPending && !state.openState) {
      // Kick-off Notification Queue
      dispatch(VUEX_NOTIFICATIONS_SHOW, state.notificationsQueue[0])
    }
  },

  [VUEX_NOTIFICATIONS_CYCLE_COMPLETE]: async ({ dispatch, commit }) => {
    await commit(VUEX_NOTIFICATIONS_CYCLE_COMPLETE)
    dispatch(VUEX_NOTIFICATIONS_PROCCESS)
  },

  [VUEX_NOTIFICATIONS_CLEAR_NOTIFICATION]: async ({ dispatch, commit }) => {
    await commit(VUEX_NOTIFICATIONS_HIDE)
    setTimeout(async () => {
      await commit(VUEX_NOTIFICATIONS_CYCLE_COMPLETE)
      dispatch(VUEX_NOTIFICATIONS_PROCCESS)
    }, 500)
  }
}

const mutations = {
  [VUEX_NOTIFICATIONS_SHOW]: (state, payload) => {
    if (payload.component) state.component = payload.component
    if (payload.data) state.data = payload.data

    if (payload.hasOwnProperty('timeout')) {
      state.timeout = parseInt(payload.timeout)
    } else {
      state.timeout = ITS__UI__NOTIFICATIONS__DELAY__DEFAULT
    }

    state.openState = true
  },

  [VUEX_NOTIFICATIONS_HIDE]: (state) => {
    state.openState = false
  },

  [VUEX_NOTIFICATIONS_SET_STATE]: (state, payload) => {
    state.openState = payload
  },

  [VUEX_NOTIFICATIONS_ADD_TO_QUEUE]: (state, payload) => {
    state.notificationsQueue = [
      ...state.notificationsQueue,
      payload
    ]
  },

  [VUEX_NOTIFICATIONS_CYCLE_COMPLETE]: (state) => {
    state.notificationsQueue.shift()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
